import { ReadOnlyStepProps } from "../useStepEditor";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { IconButton, Stack, Title } from "@introist/react-foundation/v2";
import { SelectorIcon } from "../../../employees/fields/EmployeeFieldSelector";

export const DatasetEntryUpdateViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step || !step.resolvedData) return <div />;

  const { datasetId, datasetTitle, entryId, entryTitle } = step.resolvedData as any;

  return (
    <Block blended compact>
      <StepEditorAccordion title="Data">
        <StepEditorAccordion.Row label="Dataset">
          <Stack>
            <SelectorIcon icon="files" />
            <Title variant="bold">{datasetTitle ?? "Unknown data set"}</Title>
          </Stack>
        </StepEditorAccordion.Row>
        <StepEditorAccordion.Row label="Entry">
          <Stack>
            <SelectorIcon icon="file" />
            <Title variant="bold">{entryTitle ?? "Unknown entry"}</Title>
            <IconButton
              icon="moveTo"
              onClick={() => window.open(`/datasets/${datasetId}/${entryId}`, "_blank")}
              dimmed
              style={{ marginLeft: "auto" }}
            />
          </Stack>
        </StepEditorAccordion.Row>
      </StepEditorAccordion>
    </Block>
  );
};
